<template>

  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            v-if="isMobile()"
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-space_between mb-1 mb-md-0"
          >
            <span class="text-muted">Showing <br>{{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>

          <b-col
            v-else
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>

              <b-dropdown
                id="dropdown-form-all-announcement-category"
                ref="filter_dropdown_all_announcement"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <announcement-dropdown-filters
                  :announcement-category.sync="announcementCategoryFilter"
                  :highlight-filter.sync="highlightFilter"
                  :status-filter.sync="statusFilter"
                  :start-date.sync="startDateFilter"
                  :department-filter.sync="departmentFilter"
                  :announcement-cat-options="announcementCatOptions"
                  :department-options="departmentOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="departmentFilter.length || startDateFilter || announcementCategoryFilter.length || statusFilter.length || highlightFilter.length">
          <hr
            v-if="startDateFilter || statusFilter.length || highlightFilter.length"
            class="dividerHR filter-divider"
          >
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-if="startDateFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="startDateFilter = ''"
                  >
                    {{ startDateFilter }}
                  </b-form-tag>
                </li>
                <template v-if="!$route.params.id">
                  <li
                    v-for="catVal in announcementCategoryFilter"
                    :key="catVal"
                    class="list-inline-item"
                  >
                    <b-form-tag
                      class="mb-50"
                      variant="danger"
                      @remove="removeFromCategoryFilter(catVal)"
                    >
                      <span class="text-capitalize"><span class="text-capitalize">{{ resolveAnnouncementCatName(catVal) }}</span></span>
                    </b-form-tag>
                  </li>
                </template>
                <li
                  v-for="catVal in statusFilter"
                  :key="catVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromStatusFilter(catVal)"
                  >
                    <span class="text-capitalize"><span class="text-capitalize">{{ catVal == 'pending' ? 'pending verification' : catVal }}</span></span>
                  </b-form-tag>
                </li>

                <li
                  v-for="departmentVal in departmentFilter"
                  :key="departmentVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromDepartmentFilter(departmentVal)"
                  >
                    <span class="text-capitalize">{{ resolveDepartmentName(departmentVal) }}</span>
                  </b-form-tag>
                </li>

                <li
                  v-for="catVal in highlightFilter"
                  :key="catVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromHighlightFilter(catVal)"
                  >
                    <span class="text-capitalize"><span class="text-capitalize">{{ catVal }}</span></span>
                  </b-form-tag>
                </li>
                <li
                  v-if="startDateFilter || statusFilter.length || highlightFilter.length"
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refAnnouncementsTable"
        class="position-relative event_list min-height-300"
        :items="fetchAnnouncements"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(title)="data">
          <div class="">
            <b-button
              v-if="canViewThisAction('show', 'Announcement')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'agencies-announcements-show', params: { id: data.item._id } }"
            >
              {{ data.item.title }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.title }}
            </b-button>
          </div>
        </template>

        <template #cell(content)="data">
          <!-- eslint-disable vue/no-v-html -->
          <div
            class="text-wrap-multi-line rich-text-modify"
            v-html="data.item.content"
          />
        </template>

        <template #cell(departments)="data">
          <div class="text-wrap">
            <span
              v-for="(dept, deptIndex) in data.item.departments"
              :key="deptIndex"
            >
              {{ dept.name }}<span v-if="data.item.departments.length != deptIndex + 1">, </span>
            </span>
          </div>
        </template>

        <template #cell(categories)="data">
          <div class="text-wrap">
            <span
              v-for="(cat, catIndex) in data.item.categories"
              :key="catIndex"
            >
              {{ cat.name }}<span v-if="data.item.categories.length != catIndex + 1">, </span>
            </span>
          </div>
        </template>

        <template #cell(highlight)="data">
          <div class="">
            <span class="text-capitalize">{{ data.item.highlight ? 'Yes' : 'No' }}</span>
            <br>
            <span v-if="data.item.highlight">{{ data.item.fromDate ? dateFormatWithTime(data.item.fromDate) : '-' }} - {{ data.item.toDate ? dateFormatWithTime(data.item.toDate) : '-' }}</span>
          </div>
        </template>

        <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span>{{ data.item.createdBy.name }}</span>
            <br>
            <span class="">{{ dateFormatWithTime(data.item.createdAt) }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="`light-${resolveAnnouncementStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status == 'pending' ? 'Pending Verification' : data.item.status }}
          </b-badge>
          <div v-if="data.item.status == 'published'">
            <span class="">{{ data.item.publishedAt ? dateFormat(data.item.publishedAt) : '-' }}</span>
          </div>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('create', 'Announcement') || canViewThisAction('show', 'Announcement') || canViewThisAction('update', 'Announcement') || canViewThisAction('delete', 'Announcement')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('show', 'Announcement')"
              :to="{ name: 'agencies-announcements-show', params: { id: data.item._id } }"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Announcement')"
              :to="{ name: 'agencies-announcements-edit', params: { id: data.item._id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update-status', 'Announcement')"
              id="toggle-btn"
              v-b-modal.modal-update-status-all-announcement
              @click="setAnnouncement(data.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Update Status</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('delete', 'Announcement')"
              @click="deleteEntity(data.item._id)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalAnnouncements > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalAnnouncements"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>

    <b-modal
      id="modal-update-status-all-announcement"
      ref="update-status-modal"
      modal-class="status-update-modal"
      cancel-variant="flat-primary"
      ok-variant="success"
      ok-title="Update"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Update Status"
      @ok="submitForm"
    >
      <b-form @submit.prevent="submitForm">
        <validation-observer
          ref="announcementStatusEditForm"
        >
          <b-form-group
            label="Status*"
            label-for="h-announcement-status"
          >
            <validation-provider
              #default="{ errors }"
              name="Status"
              vid="status"
              rules="required"
            >
              <v-select
                id="h-announcement-status"
                v-model="status"
                label="title"
                :options="statusDataOptions"
                :reduce="title => title.code"
                :clearable="false"
                @input="statusValidation == true ? statusValidation = false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="statusValidation"
                class="text-danger"
              >
                {{ statusError }}
              </small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend, BButton,
  BBadge, BDropdown, BDropdownItem, BPagination, BForm, BFormGroup, BFormTag,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ref, onUnmounted, computed } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

import store from '@/store'

import useAllAnnouncementList from './useAllAnnouncementList'
import announcementStoreModule from '../announcementStoreModule'
import AnnouncementDropdownFilters from '../AnnouncementFilters.vue'

export default {
  components: {
    BForm,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormTag,
    BButton,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    vSelect,

    AnnouncementDropdownFilters,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      announcementID: '',
      title: '',
      status: 'active',
      bulkStatus: 'active',
      bulkCategory: '',
      statusValidation: false,
      statusError: 'Valid status is required',
      bulkStatusValidation: false,
      bulkStatusError: 'Valid status is required',
      bulkCategoryValidation: false,
      bulkCategoryError: 'Valid category is required',
      statusDataOptions: [
        { title: 'Draft', code: 'draft' },
        { title: 'Published', code: 'published' },
        { title: 'Unpublished', code: 'unpublished' },
        { title: 'Pending Verification', code: 'pending' },
      ],
      announcementCatOptions: [],
      departmentOptions: [],
      showFilterDropdown: process.env.VUE_APP_SHOW_FILTER_DROPDOWN,

      required,
    }
  },
  beforeMount() {
    this.$http.get('customer/announcements/respond-with/category-options')
      .then(response => {
        this.announcementCatOptions = response.data.categoryOptions ?? []
        this.departmentOptions = response.data.departmentOptions || []
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_all_announcement.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_all_announcement.show(true)
    },
    removeFromCategoryFilter(item) {
      const index = this.announcementCategoryFilter.indexOf(item)
      if (index > -1) {
        this.announcementCategoryFilter.splice(index, 1)
      }
    },
    removeFromDepartmentFilter(item) {
      const index = this.departmentFilter.indexOf(item)
      if (index > -1) {
        this.departmentFilter.splice(index, 1)
      }
    },
    removeFromStatusFilter(item) {
      const index = this.statusFilter.indexOf(item)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },
    removeFromHighlightFilter(item) {
      const index = this.highlightFilter.indexOf(item)
      if (index > -1) {
        this.highlightFilter.splice(index, 1)
      }
    },
    resolveAnnouncementCatName(id) {
      const category = this.announcementCatOptions.find(o => o._id === id)
      if (category) {
        return category.name || ''
      }
      return ''
    },
    resolveDepartmentName(id) {
      const dept = this.departmentOptions.find(o => o._id === id)
      if (dept) {
        return dept.name || ''
      }
      return ''
    },
    clearAllFilters() {
      this.startDateFilter = ''
      if (!this.$route.params.id) {
        this.announcementCategoryFilter = []
      }
      this.departmentFilter = []
      this.statusFilter = []
      this.highlightFilter = []
    },
    setAnnouncement(item) {
      this.announcementID = item._id
      this.status = item.status
      this.title = item.title
    },
    submitForm() {
      this.$refs.announcementStatusEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('status', this.status)

          this.$http.patch(`customer/announcements/${this.announcementID}/status/update`, formData)
            .then(() => {
              this.refetchData()
              this.$emit('emitCountAnnouncement')
              // this.$nextTick(() => {
              //   this.$refs['update-status-modal'].toggle('#toggle-btn')
              // })
              this.$swal({
                title: 'Status Updated!',
                html: `The status for <strong>‘${this.title}’</strong> has been updated`,
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'status') {
                    this.statusError = validationError.msg
                    this.statusValidation = true
                  }
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
    deleteEntity(id) {
      this.$swal({
        title: 'Delete this Announcement?',
        html: 'Are you sure you want to delete this announcement? This cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/delete-yellow.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: 'Yes, delete',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.toDeletedID = id
            await this.deleteAnnouncement()
            this.$emit('emitCountAnnouncement')
          }
        })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const ARTICLE_APP_STORE_MODULE_NAME = 'agencies-all-announcements'

    // Register module
    if (!store.hasModule(ARTICLE_APP_STORE_MODULE_NAME)) store.registerModule(ARTICLE_APP_STORE_MODULE_NAME, announcementStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ARTICLE_APP_STORE_MODULE_NAME)) store.unregisterModule(ARTICLE_APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    const { canViewThisAction } = useAclUtils()

    const {
      fetchAnnouncements,
      tableColumns,
      perPage,
      currentPage,
      totalAnnouncements,
      announcementData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refAnnouncementsTable,
      refetchData,

      toDeletedID,
      deleteAnnouncement,

      // UI
      resolveAnnouncementStatusVariant,

      // Extra Filters
      announcementCategoryFilter,
      startDateFilter,
      highlightFilter,
      statusFilter,
      departmentFilter,
    } = useAllAnnouncementList()

    const selectedAnnouncements = ref([])
    const toggleSelectedAnnouncements = announcementID => {
      const announcementIndex = selectedAnnouncements.value.indexOf(announcementID)

      if (announcementIndex === -1) selectedAnnouncements.value.push(announcementID)
      else selectedAnnouncements.value.splice(announcementIndex, 1)
    }
    const selectAllAnnouncementCheckbox = computed(() => announcementData.value.length && (announcementData.value.length === selectedAnnouncements.value.length))
    const isSelectAllAnnouncementCheckboxIndeterminate = computed(() => Boolean(selectedAnnouncements.value.length) && announcementData.value.length !== selectedAnnouncements.value.length)
    const selectAllCheckboxUpdate = val => {
      selectedAnnouncements.value = val ? announcementData.value.map(book => book._id) : []
    }

    return {

      // Sidebar

      fetchAnnouncements,
      tableColumns,
      perPage,
      currentPage,
      totalAnnouncements,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refAnnouncementsTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      toDeletedID,
      deleteAnnouncement,
      announcementData,

      // Filter
      avatarText,
      canViewThisAction,

      // UI
      resolveAnnouncementStatusVariant,

      statusOptions,

      // Extra Filters
      announcementCategoryFilter,
      startDateFilter,
      highlightFilter,
      statusFilter,
      departmentFilter,

      selectAllAnnouncementCheckbox,
      isSelectAllAnnouncementCheckboxIndeterminate,
      selectedAnnouncements,
      toggleSelectedAnnouncements,
      selectAllCheckboxUpdate,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
